import { newAxios } from "./index";
const userId = true

//获取商机列表
export function Req_GetBusinessList(data) {
  return newAxios({
    url: `/i/crm/business/opp/page/list`,
    data,
  },'json')()
}
//获取商机状态列表
export function Req_GetOppStatusList(data){
  return newAxios({
    url:`/i/crm/business/opp/list/status`,
    data
  })()
}

//获取商机详情
export function Req_GetBusinessDetail(data){
  return newAxios({
    url:`/i/crm/business/opp/info/${data.oppId}`,
  })()
}

//新增商机
export function Req_AddBusinessOpportunity(data){
  return newAxios({
    url:`/i/crm/business/opp/add`,
    data
  },'json')()
}

// 删除商机
export function Req_DelBusinessOpportunity(data){
  return newAxios({
    url:`/i/crm/business/opp/delete/${data.oppId}`,
  })()
}

//修改商机
export function Req_UpdateBusinessOpportunity(data){
  return newAxios({
    url:`/i/crm/business/opp/update`,
    data
  },'json')()
}


//获取人员列表
export function Req_GetUserList(data){
  return newAxios({
    url:`/i/tenant/crm/customer/user/Lite`,
    data
  })()
}

//推荐人列表
export function Req_GetReferrerList(data){
  return newAxios({
    url:`/i/tenant/crm/referrer/list`,
    data
  })()
}

//获取筛选列表 ，传入参数filterObj的值为10 ，外部写死
export function Req_GetFilterList(data){
  return newAxios({
    url:`/i/tenant/crm/filter/list/by/object`,
    data
  })()
}

//获取列表的表头设置
export function Req_GetListHeader(data){
  return newAxios({
    url:`/i/tenant/crm/list/header/config/list`,
    data
  })()
}

//保存列表表头
export function Req_SaveListHeader(data){
  return newAxios({
    url:`/i/tenant/crm/list/header/config/save`,
    data
  },'json')()
}

//转移商机
export function Req_TransferBusinessOpportunity(data){
  return newAxios({
    url:`/i/crm/business/opp/transfer`,
    data
  })()
}

//修改商机协助人
export function Req_UpdateHelpers(data){
  return newAxios({
    url:`/i/crm/business/opp/update/helpers`,
    data
  },'json')()
}

//新增联系人
export function Req_AddContactPerson(data){
  return newAxios({
    url:`/i/crm/tenant/contact/add`,
    data
  },'json')()
}

//修改联系人
export function Req_UpdateContactPerson(data){
  return newAxios({
    url:`/i/crm/tenant/contact/update`,
    data
  },'json')()
}

//删除联系人
export function Req_DelContactPerson(data){
  return newAxios({
    url:`/i/crm/tenant/contact/delete/${data.contactId}`,
  })()
}

//获取基础配置列表
export function Req_GetBaseConfigList(data){
  return newAxios({
    url:`/i/crm/tenant/base/config/list`,
    data
  })()
}

//新增基础配置
export function Req_AddBaseConfig(data){
  return newAxios({
    url:`/i/crm/tenant/base/config/add`,
    data
  },'json')()
}

//修改基础配置
export function Req_UpdateBaseConfig(data){
  return newAxios({
    url:`/i/crm/tenant/base/config/update`,
    data
  },'json')()
}

//删除基础配置
export function Req_DelBaseConfig(data){
  return newAxios({
    url:`/i/crm/tenant/base/config/delete/${data.configId}`
  })()
}


//新增跟进记录
export function Req_AddFollowRecord(data){
  return newAxios({
    url:`/i/crm/tenant/opp/follow/record/add`,
    data
  },'json')()
}

//修改跟进记录
export function Req_UpdateFollowRecord(data){
  return newAxios({
    url:`/i/crm/tenant/opp/follow/record/update`,
    data
  },'json')()
}

//删除跟进记录
export function Req_DelFollowRecord(data){
  return newAxios({
    url:`/i/crm/tenant/opp/follow/record/delete/${data.recordId}`,
    data
  })()
}


//获取跟进方式列表
export function Req_GetFollowTypes(){
  return newAxios({
    url:`/i/crm/tenant/opp/follow/record/list/follow/types`,
  })()
}

//查看跟进记录内容
export function Req_GetFollowRecordInfo(data){
  return newAxios({
    url:`/i/crm/tenant/opp/follow/record/info/${data.recordId}`
  })()
}

//获取产品列表
export function Req_GetProductList(data) {
  return newAxios({
    url: `/i/tenant/crm/service/product/page`,
    data
  })()
}


//获取分类列表
export function Req_GetCategoryList(data) {
  return newAxios({
    url: `/i/tenant/crm/service/product/category/tree/${data.type}`,
    data
  })()
}

//新增分类
export function Req_AddCategory(data) {
  return newAxios({
    url: `/i/tenant/crm/service/product/category/add`,
    data
  },'json')()
}

//修改分类
export function Req_UpdateCategory(data) {
  return newAxios({
    url: `/i/tenant/crm/service/product/category/update`,
    data
  },'json')()
}

//删除分类
export function Req_DeleteCategory(data) {
  return newAxios({
    url: `/i/tenant/crm/service/product/category/delete/${data.code}`
  })()
}

//获取单位列表
export function Req_GetUnitList(data) {
  return newAxios({
    url:`/i/tenant/crm/service/product/unit/page`,
    data
  })()
}

//新增单位
export function Req_AddUnit(data) {
  return newAxios({
    url: `/i/tenant/crm/service/product/unit/add/${data.name}`
  })()
}

//上下架产品/套餐
export function Req_UpdateShelf(data) {
  return newAxios({
    url: `/i/tenant/crm/service/product/update/shelf`,
    data
  })()
}

//批量删除产品/套餐
export function Req_BatchDeleteProduct(data) {
  return newAxios({
    url: `/i/tenant/crm/service/product/batch/delete`,
    data
  },'json')()
}


//获取编号
export function Req_GetSerialNum(data) {
  return newAxios({
    url: `/i/tenant/crm/service/product/serial/num`
  })()
}

//新增产品/套餐
export function Req_AddProduct(data) {
  return newAxios({
    url: `/i/tenant/crm/service/product/add`,
    data
  },'json')()
}

//修改产品/套餐
export function Req_UpdateProduct(data) {
  return newAxios({
    url: `/i/tenant/crm/service/product/update`,
    data
  },'json')()
}

//订单列表
export function Req_GetOrderList(data) {
  return newAxios({
    url: `/i/tenant/crm/service/order/page/list`,
    data
  },'json')()
}

export function Req_GetOrderDictionary(data) {
  return newAxios({
    url:`/i/tenant/crm/service/order/dictionary`
  })()
}

//模糊搜索客户信息
export function Req_GetCustomInfo(data) {
  return newAxios({
    url: `/i/tenant/crm/service/order/fuzzy/match/customer/${data.keyword}`
  })()
}

//获取租户所有的CRM产品/套餐(树结构)
export function Req_GetProductTree(data) {
  return newAxios({
    url:`/i/tenant/crm/service/product/all/group/tree`,
    data
  })()
}

//新增业务订单
export function Req_AddOrder(data) {
  return newAxios({
    url:`/i/tenant/crm/service/order/add`,
    data
  },'json')()
}

//订单详情
export function Req_GetOrderInfo(data) {
  return newAxios({
    url: `/i/tenant/crm/service/order/info/${data.orderId}`
  })()
}

//修改金额
export function Req_EditOrderPrice(data) {
  return newAxios({
    url:`/i/tenant/crm/service/order/edit/price`,
    data
  })()
}

//修改订单状态
export function Req_EditOrderStatus(data) {
  return newAxios({
    url:`/i/tenant/crm/service/order/edit/status`,
    data
  })()
}

//删除订单
export function Req_DeleteOrder(data) {
  return newAxios({
    url:`/i/tenant/crm/service/order/delete/${data.orderId}`
  })()
}

//修改订单
export function Req_UpdateOrder(data) {
  return newAxios({
    url: `/i/tenant/crm/service/order/update`,
    data
  },'json')()
}

export function Req_GetOrderLogs(data) {
  return newAxios({
    url: `/i/tenant/crm/service/order/logs`,
    data
  })()
}

//订单指派人员
export function Req_AssignOrder(data) {
  return newAxios({
    url: `/i/tenant/crm/service/order/assign`,
    data
  })()
}

//推荐人整合列表
export function Req_GetOrderReferrer(data) {
  return newAxios({
    url: `/i/tenant/crm/referrer/consolidation/list`
  })()
}

//保存办证类订单模板
export function Req_SaveOrderTemplate(data) {
  return newAxios({
    url: `/i/tenant/crm/service/order/save/template`,
    data
  },'json')()
}

//保存业务指引记录到已有商机
export function Req_SaveGuideRecord(data) {
  return newAxios({
    url:`/i/crm/business/opp/save/guide/record`,
    data
  },'json')()
}

//获取订单结算信息
export function Req_GetOrderSettle(data) {
  return newAxios({
    url:`/i/tenant/crm/service/order/settle/info`,
    data
  })()
}

//修改商机状态
export function Req_EditOppStatus(data) {
  return newAxios({
    url:`/i/crm/business/opp/edit/status`,
    data
  })()
}

//商机操作记录列表
export function Req_GetOppLogs(data) {
  return newAxios({
    url:`/i/crm/business/opp/logs`,
    data
  })()
}

//获取员工新列表
export function Req_GetNewUserList(data) {
  return newAxios({
    url:`/i/tenant/user/permission/list/staffs`,
    data
  },'json')()
}

//手动结算
export function Req_HandleSettle(data){
  return newAxios({
    url: `/i/tenant/crm/service/order/settle/manual`,
    data
  })()
}

//查询通联交易结果
export function Req_GetOrderTradeResult(data) {
  return newAxios({
    url:`/i/tenant/crm/service/order/trade/result`,
    data
  },'',false)()
}

//批量设置产品分类负责人
export function Req_BatchSetPrincipal(data) {
  return newAxios({
    url:`/i/tenant/crm/service/product/category/batch/set/principal`,
    data
  },'json')()
}

//商机负责人调度
export function Req_ScheduleOpp(data){
  return newAxios({
    url:`/i/crm/business/opp/schedule/commissioners`,
    data
  },'json')()
}

//产品标签列表
export function Req_GetProductLabel(data) {
  return newAxios({
    url:`/i/tenant/crm/service/product/category/label/list`,
    data
  })()
}

//新增产品标签
export function Req_AddProductLabel(data) {
  return newAxios({
    url: `/i/tenant/crm/service/product/category/label/add`,
    data
  },'json')()
}

//业务订单拆单
export function Req_SplitOrder(data) {
  return newAxios({
    url: `/i/tenant/crm/service/order/split`,
    data
  },'json')()
}

//查询意向产品
export function Req_SearchProductDemand(data) {
  return newAxios({
    url:`/i/tenant/crm/service/product/list/product/demands`,
    data
  },'json')()
}

//更新收款记录的交易单号
export function Req_UpdateOrderTradeNum(data) {
  return newAxios({
    url:`/i/tenant/crm/service/order/update/trade/num`,
    data
  })()
}

//订单变更服务顾问
export function Req_ChangeOrderPrincipal(data) {
  return newAxios({
    url:`/i/tenant/crm/service/order/change/principal`,
    data
  })()
}

//获取当前账号客户
export function Req_GetCustomerList(data) {
  return newAxios({
    url:`/i/tenant/crm/service/order/customers`
  })()
}


//获取意向产品列表（含调度）
export function Req_GetScheduleProduct(data) {
  return newAxios({
    url:`/i/tenant/crm/service/product/category/demand/list`,
    data
  })()
}

//新建订单(新)
export function Req_AddNewOrder(data) {
  return newAxios({
    url:`/i/tenant/crm/service/order/modify/add`,
    data
  },'json')()
}

//获取订单(新)
export function Req_GetNewOrer(data) {
  return newAxios({
    url:`/i/tenant/crm/service/order/modify/info/${data.orderId}`
  })()
}

//修改订单(新)
export function Req_UpdateNewOrder(data) {
  return newAxios({
    url:`/i/tenant/crm/service/order/modify/update`,
    data
  },'json')()
}

//订单结算(新)
export function Req_SettleNewOrder(data) {
  return newAxios({
    url:`/i/tenant/crm/service/order/settle/message`,
    data
  })()
}

//手动结算订单（新）
export function Req_HandleSettleNewOrder(data) {
  return newAxios({
    url:`/i/tenant/crm/service/order/manually/settle`,
    data
  },'json')()
}

//修改业务订单状态(新)
export function Req_EditNewOrderStatus(data) {
  return newAxios({
    url:`/i/tenant/crm/service/order/modify/edit/status`,
    data
  })()
}

//更新结算记录交易单号（新）
export function Req_EditNewOrderNum(data) {
  return newAxios({
    url:`/i/tenant/crm/service/order/settle/update/trade/num`,
    data
  })()
}


//获取集团内的其他租户
export function Req_GetOtherGroup(data) {
  return newAxios({
    url:`/i/tenant/user/mechanism/other/group`
  })()
}

//获取租户意向产品
export function Req_GetGroupProduct(data) {
  return newAxios({
    url:`/i/tenant/crm/service/product/category/demand/group`,
    data
  })()
}


//新建订单查询是否有权限填写一级推荐人
export function Req_isAddRefPermission(data) {
  return newAxios({
    url:`/i/tenant/crm/service/order/data/permission/check`
  })()
}


//获取账户列表
export const Req_GetPaymentAccList = function (data) {
  return newAxios({
    url: `/i/tenant/crm/service/payment/account/page/list`,
    data
  })()
}



// WEBPACK FOOTER //
// ./src/request/business.js